<div class="body-padding" id="service-request-page">
  <div class="flex flex-col items-baseline mb-4">
    <h1 class="general-font text-4xl font-bold text-gray-900" id="service-request-title">Add Service Request</h1>
  </div>

  <div class="flex flex-wrap gap-4 items-baseline align-baseline">
    <div class="w-fit min-w-[130px] mr-3">
      <div>
        <label for="service-request-depot-select" class="block mb-2 text-sm font-medium text-gray-900">ReNew Depot Ship
          To<span class="text-red-500">*</span></label>
        <ng-select
          id="service-request-depot-select"
          [(ngModel)]="depotId"
          [items]="depots"
          bindValue="service_request_depot_id"
          bindLabel="address"
          placeholder="Select Ship To Address"
          class="select-custom"
          required
          (ngModelChange)="depotChanged($event)"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="text-sm" id="service-request-depot-option-{{item.service_request_depot_id}}">
              {{ item.address }}, {{ item.city }}, {{ item.zip_code }}
            </div>
          </ng-template>
        </ng-select>

        @if (!isDepotValid) {
          <div class="text-red-600 text-sm" id="service-request-depot-error">
            Ship To Address is required.
          </div>
        }
      </div>
    </div>
  </div>

  <div class="flex flex-wrap gap-4 items-baseline align-baseline mt-1.5 mb-5">
    <div class="w-fit min-w-[120px] mr-3">
      <div>
        <label for="service-request-location-select"
               class="block mb-2 text-sm font-medium text-gray-900">Location</label>
        <ng-select
          id="service-request-location-select"
          [items]="locations"
          bindValue="location_id"
          bindLabel="location_name"
          [searchable]="true"
          [searchFn]="customSearchFn"
          placeholder="Select or type Location"
          [(ngModel)]="locationId"
          (ngModelChange)="filterChanged()"
          class="select-custom">
          <ng-template ng-label-tmp let-item="item">
            <div class="text-sm" id="service-request-location-option-{{item.location_id}}">
              <span>{{ item.location_name }}</span>
            </div>
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <div class="flex flex-col text-sm" id="service-request-location-option-{{item.location_id}}">
              <span>{{ item.location_name }}</span>
              @if (item.full_address) {
                <span>{{ item.full_address }}</span>
              }
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  @if (assets.length > 0) {
    <div [formGroup]="masterFormGroup" class="w-full max-w-[1100px] pb-[25px]"
         id="service-request-assets-container">
      @for (asset of assets; track asset; let i = $index) {
        <div class="flex flex-col mb-4" id="service-request-asset-{{i}}">
          <service-request-asset-component [initAsset]="asset" [assetIndex]="i" [assetsCount]="assets.length"
                                           [parentForm]="masterFormGroup" [locationId]="locationId"
                                           (deleteAsset)="handleDeleteAsset($event)"/>
        </div>
      }
      <div class="flex justify-end gap-4" id="service-request-actions">
        <button type="button" class="btn-add-asset" id="service-request-add-asset-btn" (click)="addAsset()">Add Another
          Asset
        </button>
        <button type="button" class="btn-submit" id="service-request-submit-btn" (click)="openSubmitPopup()">Submit
        </button>
      </div>
    </div>
  }

  @if (isPopupVisible) {
    <submit-service-request-popup
      id="service-request-submit-popup"
      (close)="closePopup()"
      (submit)="submitRequestWithoutPdf()"
      (submitAndCreatePdf)="submitRequestWithPdf()"/>
  }

  @if (loading) {
    <loading-overlay message="Please wait while the request is being processed..."/>
  }

  @if (isPdfExportRunning) {
    <loading-overlay message="Please wait while we are generating PDF document..."/>
  }
</div>
